import { NgModule, Injector, DoBootstrap } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { createCustomElement } from '@angular/elements';
import { DmSelectLibComponent } from '@everymatrix-base-components/dm-select-lib';
import {
  appConfig,
  patchDomHandlerGetScrollableParents,
} from '@everymatrix-base-components/utils';

@NgModule({
  imports: [BrowserModule, DmSelectLibComponent],
  providers: [...appConfig.providers],
})
export class AppModule implements DoBootstrap {
  constructor(private injector: Injector) {
    const element = createCustomElement(DmSelectLibComponent, {
      injector: this.injector,
    });
    if (!customElements.get('everymatrix-dm-select')) {
      customElements.define('everymatrix-dm-select', element);
    }

    patchDomHandlerGetScrollableParents();
  }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method,@typescript-eslint/no-empty-function
  ngDoBootstrap(): void {}
}
